import { DATAURI_DEATH_BLACK } from '../model/DATAURI_DEATH_BLACK'
import type { IPerson } from '../model/IPerson'
import type { ITreeOptions } from '../model/ITreeOptions'
import { PersonImageSize } from '../model/PersonImageSize'
import { diedAsInfant } from './diedAsInfant'
import { fetchImageToDataUri } from './fetchImageToDataUri'
import { getPersonImageUrl } from './getPersonImageUrl'

export async function getImageUrlForSvg(
	person: IPerson,
	options: ITreeOptions,
): Promise<string | undefined> {
	if (diedAsInfant(person)) {
		return DATAURI_DEATH_BLACK
	} else {
		const imageUrl = getPersonImageUrl(person.id, {
			size: options.forDownload ? undefined : PersonImageSize._96,
			emptyIfMissing: true,
		})
		if (imageUrl) {
			if (options.forDownload) {
				return await fetchImageToDataUri(imageUrl)
			} else {
				return imageUrl
			}
		}
	}
}
